import { RefObject, useEffect } from "react";

/**
 * A tab strip that scrolls sideways on a phone: keeps the active tab (the one
 * marked `aria-current="page"`) in view after a tab change or a first render.
 * A strip that fits (desktop wraps instead of scrolling) is left alone, so the
 * page is never nudged vertically.
 */
export default function useScrollActiveTabIntoView(strip: RefObject<HTMLElement>, activeTab: string) {
  useEffect(() => {
    const element = strip.current;
    if (!element || element.scrollWidth <= element.clientWidth) return;
    // jsdom has no scrollIntoView.
    element.querySelector('[aria-current="page"]')?.scrollIntoView?.({ block: "nearest", inline: "center" });
  }, [strip, activeTab]);
}
